/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { NavOption } from '../molecules';
import MediaQueries from '../tokens/MediaQueries';
import { AccountIcon, HummingbirdLogo, HummingbirdLogoText } from '../atoms';
import Colours from '../tokens/colours';
import { fadeIn, animationUsage, fadeOut } from '../tokens/Animations';
const positionElement = (top, left, zIndex) => ({
    top,
    left,
    zIndex: zIndex || 'default',
});
const pseudoElementStyle = (width, height) => ({
    position: 'absolute',
    ...positionElement(-2, 0),
    content: '""',
    width,
    height,
    backgroundColor: Colours.white,
});
const HEIGHT_MOBILE = 71;
const WIDTH_DESKTOP = 56;
const getStyles = createUseStyles({
    ...fadeIn,
    ...fadeOut,
    root: {
        position: 'relative',
        height: '100vh',
    },
    nav: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        left: 0,
        height: HEIGHT_MOBILE,
        padding: '0.8rem 2.7rem',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `3px 0px 15px ${Colours.quarternary}`,
        backgroundColor: Colours.white,
        borderRadius: 4,
        [MediaQueries.desktop]: {
            boxShadow: 'none',
            backgroundColor: 'transparent',
            padding: '3.2rem 0.8rem 1.3rem 0.8rem',
            height: '100%',
            position: 'fixed',
            width: WIDTH_DESKTOP,
            marginLeft: 0,
            ...positionElement(0, 0, 100),
            '&:after': {
                ...pseudoElementStyle(56, '100%'),
                position: 'absolute',
                ...positionElement(0, 0, 1),
                boxShadow: `0px 3px 15px ${Colours.quarternary}`,
            },
            '&:before': {
                boxShadow: `0px 3px 15px ${Colours.quarternary}`,
                content: '" "',
                height: '100%',
                width: '100%',
                position: 'absolute',
                backgroundColor: Colours.white,
                top: 0,
                left: 0,
                display: 'none',
            },
        },
    },
    fadeOut: {
        [MediaQueries.desktop]: {
            width: 176,
            '&::before': {
                display: 'block',
                ...animationUsage('$fadeOut', '0.5s'),
            },
        },
    },
    rootHovered: {
        [MediaQueries.desktop]: {
            width: 176,
            '&:after': {
                boxShadow: `none`,
            },
            '&:before': {
                display: 'block',
            },
        },
    },
    list: {
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        [MediaQueries.desktop]: {
            display: 'block',
            marginBottom: 0,
            alignItems: 'flex-start',
        },
    },
    accountOption: {
        [MediaQueries.desktop]: {
            margin: '0 0 7.2rem 0',
        },
    },
    logo: {
        width: '9.578rem',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    logoWrapper: {
        display: 'none',
        [MediaQueries.desktop]: {
            height: '5.8rem',
            display: 'flex',
            alignItems: 'center',
            padding: '13px 8px 13px 0',
            position: 'relative',
            width: WIDTH_DESKTOP - 8,
            zIndex: 9999,
            '&:before': {
                position: 'absolute',
                top: -2,
                left: 0,
                content: '""',
                width: WIDTH_DESKTOP - 16,
                height: 2,
                backgroundColor: Colours.quarternary,
            },
            '&:after': {
                position: 'absolute',
                top: -2,
                left: 0,
                content: '""',
                height: 2,
                backgroundColor: Colours.quarternary,
                width: 176 - 16,
                display: 'none',
                ...animationUsage('$fadeOut', '0.5s'),
            },
        },
    },
    logoWrapperHovered: {
        '&::after': {
            display: 'block',
            ...animationUsage('$fadeIn', '0.5s'),
        },
    },
    logoTextPosition: {
        position: 'absolute',
        height: '100%',
        ...animationUsage('$fadeIn', '0.5s'),
    },
    hidden: {
        ...animationUsage('$fadeOut', '0.5s'),
        display: 'none',
    },
    iconColour: {
        color: Colours.sexternary,
    },
    iconSelectedColour: {
        color: Colours.primary,
    },
    accountDots: {
        '&:after': {
            [MediaQueries.desktop]: {
                content: '"\u2807"',
                fontSize: 26,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                height: '100%',
                marginRight: 0,
                marginLeft: 'auto',
                paddingLeft: 5,
                color: Colours.sexternary,
                ...animationUsage('$fadeIn', '0.5s'),
            },
        },
    },
    accountDotsActive: {
        '&:after': {
            [MediaQueries.desktop]: {
                color: Colours.primary,
            },
        },
    },
    content: {
        height: '100vh',
        overflowX: 'auto',
        paddingBottom: HEIGHT_MOBILE,
        [MediaQueries.desktop]: {
            paddingBottom: 0,
            paddingLeft: WIDTH_DESKTOP
        }
    }
});
const resetIsFadingOut = setIsFadingOut => {
    setTimeout(() => setIsFadingOut(false), 500);
};
const hoverHandler = (booleanSet, setIsNavbarHovered, setIsFadingOut) => {
    setIsNavbarHovered(booleanSet);
    if (!booleanSet)
        setIsFadingOut(true);
    resetIsFadingOut(setIsFadingOut);
};
const validateSelected = (elementName, comparisonOne) => comparisonOne === elementName;
const handleClick = (e, setSelected, optionClick) => {
    const target = e.target;
    setSelected(target.id);
    if (optionClick)
        optionClick();
};
const GlobalLayout = ({ className, optionsList = [], accountName = 'Hummingbird', children, }) => {
    const styles = getStyles();
    const [selected, setSelected] = useState('');
    const [isNavbarHovered, setIsNavbarHovered] = useState(false);
    const [isFadingOut, setIsFadingOut] = useState(false);
    const account = {
        iconElement: AccountIcon,
        optionName: accountName,
        to: 'account',
    };
    return (React.createElement("div", { className: classNames(styles.root, className) },
        React.createElement("nav", { className: classNames(styles.nav, { [styles.rootHovered]: isNavbarHovered }, { [styles.fadeOut]: isFadingOut }), onMouseEnter: () => hoverHandler(true, setIsNavbarHovered, setIsFadingOut), onMouseLeave: () => hoverHandler(false, setIsNavbarHovered, setIsFadingOut) },
            React.createElement("ul", { className: classNames(styles.list) },
                React.createElement(NavOption, { onClick: e => handleClick(e, setSelected), icon: React.createElement(AccountIcon, { className: validateSelected(accountName, selected)
                            ? styles.iconSelectedColour
                            : styles.iconColour, size: "large", accountInitial: accountName.charAt(0) }), optionName: account.optionName, selected: selected, className: classNames(styles.accountOption, {
                        [styles.accountDots]: isNavbarHovered,
                    }, {
                        [styles.accountDotsActive]: validateSelected(accountName, selected),
                    }), isNavbarHovered: isNavbarHovered, to: account.to }),
                optionsList.map(item => (React.createElement(NavOption, { key: item.optionName, icon: React.createElement(item.iconElement, { className: validateSelected(item.optionName, selected)
                            ? styles.iconSelectedColour
                            : styles.iconColour }), optionName: item.optionName, selected: selected, isNavbarHovered: isNavbarHovered, to: item.to, onClick: e => handleClick(e, setSelected, item.clickHandler && item.clickHandler) })))),
            React.createElement("div", { className: classNames(styles.logoWrapper, {
                    [styles.logoWrapperHovered]: isNavbarHovered,
                }) },
                React.createElement(HummingbirdLogo, { className: styles.logo }),
                React.createElement(HummingbirdLogoText, { className: classNames(styles.logo, styles.logoTextPosition, {
                        [styles.hidden]: !isNavbarHovered,
                    }) }))),
        React.createElement("div", { className: styles.content }, children)));
};
export default GlobalLayout;
//# sourceMappingURL=GlobalLayout.js.map